/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Remotex.Api, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null
 * OpenAPI spec version: 1.0
 */
import type {
  ApiEnvelopeBotAuthInitiateResponse,
  ApiEnvelopeBotAuthKeepaliveResponse,
  ApiEnvelopeBotAuthRefreshResponse,
  ApiEnvelopeBotAuthRevokeResponse,
  ApiEnvelopeBotAuthStatusResponse,
  BotAuthInitiateRequest,
  BotAuthKeepaliveRequest
} from './schemas';

import { useSfetchMutator } from '../sfetchMutator';


export type botAuthInitiateAuthResponse200 = {
  data: ApiEnvelopeBotAuthInitiateResponse
  status: 200
}

export type botAuthInitiateAuthResponse400 = {
  data: ApiEnvelopeBotAuthInitiateResponse
  status: 400
}

export type botAuthInitiateAuthResponse401 = {
  data: ApiEnvelopeBotAuthInitiateResponse
  status: 401
}

export type botAuthInitiateAuthResponse403 = {
  data: ApiEnvelopeBotAuthInitiateResponse
  status: 403
}

export type botAuthInitiateAuthResponse404 = {
  data: ApiEnvelopeBotAuthInitiateResponse
  status: 404
}

export type botAuthInitiateAuthResponseSuccess = (botAuthInitiateAuthResponse200) & {
  headers: Headers;
};
export type botAuthInitiateAuthResponseError = (botAuthInitiateAuthResponse400 | botAuthInitiateAuthResponse401 | botAuthInitiateAuthResponse403 | botAuthInitiateAuthResponse404) & {
  headers: Headers;
};

export type botAuthInitiateAuthResponse = (botAuthInitiateAuthResponseSuccess | botAuthInitiateAuthResponseError)

export const getBotAuthInitiateAuthUrl = (botId: string,) => {




  return `/api/botengine/${botId}/auth/initiate`
}

export const useBotAuthInitiateAuthHook = (): (botId: string,
    botAuthInitiateRequest?: BotAuthInitiateRequest, options?: RequestInit) => Promise<botAuthInitiateAuthResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    botAuthInitiateRequest?: BotAuthInitiateRequest, options?: RequestInit) => {

        return customFetcher(getBotAuthInitiateAuthUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(botAuthInitiateRequest)
  }
);
      }
  }


export type botAuthAuthStatusResponse200 = {
  data: ApiEnvelopeBotAuthStatusResponse
  status: 200
}

export type botAuthAuthStatusResponse401 = {
  data: ApiEnvelopeBotAuthStatusResponse
  status: 401
}

export type botAuthAuthStatusResponse403 = {
  data: ApiEnvelopeBotAuthStatusResponse
  status: 403
}

export type botAuthAuthStatusResponse404 = {
  data: ApiEnvelopeBotAuthStatusResponse
  status: 404
}

export type botAuthAuthStatusResponseSuccess = (botAuthAuthStatusResponse200) & {
  headers: Headers;
};
export type botAuthAuthStatusResponseError = (botAuthAuthStatusResponse401 | botAuthAuthStatusResponse403 | botAuthAuthStatusResponse404) & {
  headers: Headers;
};

export type botAuthAuthStatusResponse = (botAuthAuthStatusResponseSuccess | botAuthAuthStatusResponseError)

export const getBotAuthAuthStatusUrl = (botId: string,) => {




  return `/api/botengine/${botId}/auth/status`
}

export const useBotAuthAuthStatusHook = (): (botId: string, options?: RequestInit) => Promise<botAuthAuthStatusResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getBotAuthAuthStatusUrl(botId),
  {
    ...options,
    method: 'GET'


  }
);
      }
  }


export type botAuthToggleKeepaliveResponse200 = {
  data: ApiEnvelopeBotAuthKeepaliveResponse
  status: 200
}

export type botAuthToggleKeepaliveResponse400 = {
  data: ApiEnvelopeBotAuthKeepaliveResponse
  status: 400
}

export type botAuthToggleKeepaliveResponse401 = {
  data: ApiEnvelopeBotAuthKeepaliveResponse
  status: 401
}

export type botAuthToggleKeepaliveResponse403 = {
  data: ApiEnvelopeBotAuthKeepaliveResponse
  status: 403
}

export type botAuthToggleKeepaliveResponse404 = {
  data: ApiEnvelopeBotAuthKeepaliveResponse
  status: 404
}

export type botAuthToggleKeepaliveResponseSuccess = (botAuthToggleKeepaliveResponse200) & {
  headers: Headers;
};
export type botAuthToggleKeepaliveResponseError = (botAuthToggleKeepaliveResponse400 | botAuthToggleKeepaliveResponse401 | botAuthToggleKeepaliveResponse403 | botAuthToggleKeepaliveResponse404) & {
  headers: Headers;
};

export type botAuthToggleKeepaliveResponse = (botAuthToggleKeepaliveResponseSuccess | botAuthToggleKeepaliveResponseError)

export const getBotAuthToggleKeepaliveUrl = (botId: string,) => {




  return `/api/botengine/${botId}/auth/keepalive`
}

export const useBotAuthToggleKeepaliveHook = (): (botId: string,
    botAuthKeepaliveRequest?: BotAuthKeepaliveRequest, options?: RequestInit) => Promise<botAuthToggleKeepaliveResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string,
    botAuthKeepaliveRequest?: BotAuthKeepaliveRequest, options?: RequestInit) => {

        return customFetcher(getBotAuthToggleKeepaliveUrl(botId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(botAuthKeepaliveRequest)
  }
);
      }
  }


export type botAuthForceRefreshAuthResponse200 = {
  data: ApiEnvelopeBotAuthRefreshResponse
  status: 200
}

export type botAuthForceRefreshAuthResponse400 = {
  data: ApiEnvelopeBotAuthRefreshResponse
  status: 400
}

export type botAuthForceRefreshAuthResponse401 = {
  data: ApiEnvelopeBotAuthRefreshResponse
  status: 401
}

export type botAuthForceRefreshAuthResponse403 = {
  data: ApiEnvelopeBotAuthRefreshResponse
  status: 403
}

export type botAuthForceRefreshAuthResponse404 = {
  data: ApiEnvelopeBotAuthRefreshResponse
  status: 404
}

export type botAuthForceRefreshAuthResponseSuccess = (botAuthForceRefreshAuthResponse200) & {
  headers: Headers;
};
export type botAuthForceRefreshAuthResponseError = (botAuthForceRefreshAuthResponse400 | botAuthForceRefreshAuthResponse401 | botAuthForceRefreshAuthResponse403 | botAuthForceRefreshAuthResponse404) & {
  headers: Headers;
};

export type botAuthForceRefreshAuthResponse = (botAuthForceRefreshAuthResponseSuccess | botAuthForceRefreshAuthResponseError)

export const getBotAuthForceRefreshAuthUrl = (botId: string,) => {




  return `/api/botengine/${botId}/auth/refresh`
}

export const useBotAuthForceRefreshAuthHook = (): (botId: string, options?: RequestInit) => Promise<botAuthForceRefreshAuthResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getBotAuthForceRefreshAuthUrl(botId),
  {
    ...options,
    method: 'POST'


  }
);
      }
  }


export type botAuthRevokeAuthResponse200 = {
  data: ApiEnvelopeBotAuthRevokeResponse
  status: 200
}

export type botAuthRevokeAuthResponse401 = {
  data: ApiEnvelopeBotAuthRevokeResponse
  status: 401
}

export type botAuthRevokeAuthResponse403 = {
  data: ApiEnvelopeBotAuthRevokeResponse
  status: 403
}

export type botAuthRevokeAuthResponse404 = {
  data: ApiEnvelopeBotAuthRevokeResponse
  status: 404
}

export type botAuthRevokeAuthResponseSuccess = (botAuthRevokeAuthResponse200) & {
  headers: Headers;
};
export type botAuthRevokeAuthResponseError = (botAuthRevokeAuthResponse401 | botAuthRevokeAuthResponse403 | botAuthRevokeAuthResponse404) & {
  headers: Headers;
};

export type botAuthRevokeAuthResponse = (botAuthRevokeAuthResponseSuccess | botAuthRevokeAuthResponseError)

export const getBotAuthRevokeAuthUrl = (botId: string,) => {




  return `/api/botengine/${botId}/auth`
}

export const useBotAuthRevokeAuthHook = (): (botId: string, options?: RequestInit) => Promise<botAuthRevokeAuthResponse> => {

      const customFetcher = useSfetchMutator();
      return (botId: string, options?: RequestInit) => {

        return customFetcher(getBotAuthRevokeAuthUrl(botId),
  {
    ...options,
    method: 'DELETE'


  }
);
      }
  }


